import { RouteType } from "types/RouteType";
import { agentHubRoute } from "@intrasync/ai-agent";

/**
 * Routes from `@intrasync/ai-agent`.
 *
 * The package owns its route — same pattern as `@intrasync/accounting`
 * (`accountingHubRoute`). `agentHubRoute` is the AgentHub (name "AiAgent",
 * path "/ai-agent", group "AI"). This replaces the retired legacy in-app AI
 * Agent that previously occupied "/ai-agent" under Administration.
 */
const aiAgentRoutesList: RouteType[] = [agentHubRoute as unknown as RouteType];

export default aiAgentRoutesList;
